// pages/MapaPage.jsx
import React, { useEffect } from 'react';
import ColombiaMap from '../components/maps/ColombiaMap';
// import Header from '../components/layout/Header';

const MapaPage = () => {
  useEffect(() => {
    window.dispatchEvent(new Event('scroll'));
  }, []);
  return (
    <div className="min-h-screen">
      {/* <div className="min-h-screen bg-gray-50"></div> */}
      {/* <Header /> */}
      <main>
        <ColombiaMap />
      </main>
    </div>
  );
};

export default MapaPage;